<template>
  <div id="app">
    <router-view @touchstart="touchStart" @touchEndMethod="touchEnd"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
     touchStart (touchEvent) {
        if (touchEvent.changedTouches.length !== 1) { // We only care if one finger is used
          return;
        }
        const posXStart = touchEvent.changedTouches[0].clientX;
        addEventListener('touchend', (touchEvent) => this.touchEnd(touchEvent, posXStart), {once: true});
      },
      touchEnd (touchEvent, posXStart) {
        if (touchEvent.changedTouches.length !== 1) { // We only care if one finger is used
          return;
        }
        const posXEnd = touchEvent.changedTouches[0].clientX;
        if (posXStart < posXEnd) {
          this.previous(); // swipe right
        } else if (posXStart > posXEnd) {
          this.next(); // swipe left
        }
      },
      next() {
        alert('next');
      },
      previous() {
        alert('previous');
      }
  }
}
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  background-color: rgb(43, 43, 43);
  font-family: 'Poppins', sans-serif;
  height: 100%;
}

textarea {
  font-family: 'Poppins', sans-serif;
  color: white;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: none;
  font-size: 16px;
  resize: none;
  padding: 0 0 2px 0;
}

h1,h2,h3,h4 {
  margin: 0;
  padding: 0;
}

textarea, select, input, button { outline: none; }

input {
  background-color: #7400b8;
  color: white;
  border: none;
  width: calc(100% - 8px);
  padding: 4px;
  margin: 0;
  border-radius: 10px;
}

@keyframes fadeIn {
  0%{opacity: 0;}
  100%{opacity: 1;}
}

</style>



// WEBPACK FOOTER //
// src/App.vue